import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Labelbox from "../../helpers/labelbox/labelbox";
import "./MedicineModal.css";
import ValidationLibrary from "../../helpers/ValidationLibrary/validationfunction";
import dateformat from "dateformat";
import axiosInstance from "../../api/axiosInstance";
import { apiurl } from "../../App";
import { message } from 'antd';
import { Input, notification } from "antd";
import { Spin } from "antd";

export default class MedicineMaster extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    const Upload_excel = t("Upload_excel");
    this.state = {
      disableBtn: false,
      props_loading: false,
      medicineMg: [
        {
          medicine_mg: 1,
          mg: "mg",
        },
        {
          medicine_mg: 2,
          mg: "ml",
        },
      ],
      medicineRate: {
        medicine_name: {
          value: "",
          validation: [],
          error: null,
          errmsg: null,
        },
        medicine_rate: {
          value: "",
          validation: [],
          error: null,
          errmsg: null,
        },
        medicine_percentage: {
          value: "",
          validation: [],
          error: null,
          errmsg: null,
        },
        medicine_xlsheet: {
          // value: "Upload excel sheet",
          value: Upload_excel,
          validation: [],
          error: null,
          errmsg: null,
          apiPath: null,
          dataList: null
        },
        // dosage: {
        //   value: "",
        //   validation: [{ name: "required" }],
        //   error: null,
        //   errmsg: null,
        // },
        // medicine_mg: {
        //   value: 1,
        //   validation: [{ name: "required" }],
        //   error: null,
        //   errmsg: null,
        // },
      },
    };
  }

  checkValidation = () => {

    var medicineRate = this.state.medicineRate;
    var medicineKeys = Object.keys(medicineRate);
    console.log(medicineKeys);
    /* for (var i in medicineKeys) {
      var errorcheck = ValidationLibrary.checkValidation(
        medicineRate[medicineKeys[i]].value,
        medicineRate[medicineKeys[i]].validation
      );
      console.log(errorcheck);
      medicineRate[medicineKeys[i]].error = !errorcheck.state;
      medicineRate[medicineKeys[i]].errmsg = errorcheck.msg;
    }
    var filtererr = medicineKeys.filter(
      (obj) => medicineRate[obj].error == true
    );
    console.log(filtererr.length); */

    if (medicineRate.medicine_xlsheet.apiPath != null || (medicineRate.medicine_name.value != "" && medicineRate.medicine_rate.value != "" &&
      medicineRate.medicine_percentage.value != "")) {
      if (medicineRate.medicine_xlsheet.apiPath != null && (medicineRate.medicine_name.value != "" && medicineRate.medicine_rate.value != "" &&
        medicineRate.medicine_percentage.value != "")) {
        notification.warning({
          message: "Add any one option only",
          placement: "topRight",
        });
      } else {
        this.setState({ error: false });
        this.onSubmitData();
      }
    } else {
      // medicineRate.medicine_name.errmsg = medicineRate.medicine_name.value == "" ? "Field is Required" : null;
      // medicineRate.medicine_name.error = medicineRate.medicine_name.errmsg == null ? false : true;
      // medicineRate.medicine_rate.errmsg = medicineRate.medicine_rate.value == "" ? "Field is Required" : null;
      // medicineRate.medicine_rate.error = medicineRate.medicine_rate.errmsg == null ? false : true;
      // medicineRate.medicine_percentage.errmsg = medicineRate.medicine_percentage.value == "" ? "Field is Required" : null;
      // medicineRate.medicine_percentage.error = medicineRate.medicine_percentage.errmsg == null ? false : true;
      const { t } = this.props;
      const field_required = t("field_required");
      medicineRate.medicine_name.errmsg = medicineRate.medicine_name.value == "" ? field_required : null;
      medicineRate.medicine_name.error = medicineRate.medicine_name.errmsg == null ? false : true;
      medicineRate.medicine_rate.errmsg = medicineRate.medicine_rate.value == "" ? field_required  : null;
      medicineRate.medicine_rate.error = medicineRate.medicine_rate.errmsg == null ? false : true;
      medicineRate.medicine_percentage.errmsg = medicineRate.medicine_percentage.value == "" ? field_required  : null;
      medicineRate.medicine_percentage.error = medicineRate.medicine_percentage.errmsg == null ? false : true;
      this.setState({ error: true });
    }
    this.setState({ medicineRate });
  };

  changeDynamic = async (data, key) => {
    var medicineRate = this.state.medicineRate;
    var errorcheck = ValidationLibrary.checkValidation(
      data,
      medicineRate[key].validation
    );

    if (key === "medicine_rate") {
      let rate = data.replace(/[^\d]/g, "")
      if (rate.length <= 3) medicineRate[key].value = rate;
      medicineRate[key].error = !errorcheck.state
    } else if (key === "medicine_percentage") {
      let percent = data.replace(/[^\d]/g, "")
      if (percent.length <= 2) medicineRate[key].value = percent;
      medicineRate[key].error = !errorcheck.state
    } else if (key == "medicine_xlsheet") {
      medicineRate[key].value = data.target.files[0].name;
      medicineRate[key].error = !errorcheck.state;
      medicineRate[key].errmsg = errorcheck.msg;
      let apifileData = await this.xlSheetUpload(data.target.files[0]);
    } else {
      medicineRate[key].value = data;
      medicineRate[key].error = !errorcheck.state;
      medicineRate[key].errmsg = errorcheck.msg;
    }

    this.setState({ medicineRate });
    this.setState({ [key]: data });
  };

  xlSheetUpload = (dataControl) => {
    this.setState({ props_loading: true });
    let formdata = new FormData();
    formdata.append("file", dataControl);
    axiosInstance({
      method: "POST",
      url: apiurl + "admin/uploads",
      data: formdata
    }).then(res => {
      if (res.data.message == "Data fetched successfully!") {
        var xlData = [];
        res.data.dataList = res.data.dataList.splice(1, res.data.dataList.length - 1);
        res.data.dataList.forEach(element => {
          if (element["__EMPTY_1"] != undefined) {
            element["Medicine_name"] = element["__EMPTY"];
            element["Unit"] = "1";
            element["Medicine_rate"] = element["__EMPTY_1"];
            element["Commission"] = element["__EMPTY_2"];

            // element["Medicine_name"] = element["__EMPTY_1"];
            // element["Unit"] = element["__EMPTY_2"];
            // element["Medicine_rate"] = element["__EMPTY_3"];
            // element["Commission"] = element["__EMPTY_4"];
            xlData.push(element);
          }
          // element["Medicine_rate"] = element["Medicine_rate (INR)"];
          // element["Commission"] = element["Commission %"];
        });
        var medicineRate = this.state.medicineRate;
        medicineRate["medicine_xlsheet"].apiPath = res.data.filePath;
        medicineRate["medicine_xlsheet"].dataList = xlData;
        this.setState({ props_loading: false });
        this.setState({ medicineRate });
      }
    })
  }

  onSubmitData = () => {
    this.setState({ disableBtn: true })
    var medicineRateApiData = {
      Pharmacy_id: localStorage.getItem("pharmacy_id"),
      active_flag: 1,
      medicine_name: this.state.medicineRate.medicine_name.value,
      // dosage: this.state.medicineRate.dosage.value,
      dosage: 0,
      // unit: this.state.medicineRate.medicine_mg.value,
      unit: 0,
      unit_rate: this.state.medicineRate.medicine_rate.value,
      created_by: 19,
      created_on: dateformat(new Date(), "yyyy-mm-dd hh:MM:ss"),
      modified_by: 19,
      modified_on: dateformat(new Date(), "yyyy-mm-dd hh:MM:ss"),
      commission_percentage: this.state.medicineRate.medicine_percentage.value,
      xlDataList: JSON.stringify(this.state.medicineRate.medicine_xlsheet.dataList)
    };
    if (this.props.editOpenModal === true) {
      this.medicineRateUpdateApi(medicineRateApiData); // Update Api Call
    } else {
      this.medicineRateAddApi(medicineRateApiData); // Insert Api Call
    }
    //this.props.closemodal();
  };

  medicineRateAddApi = (medicineRateApiData) => {
    this.setState({ props_loading: true });
    axiosInstance({
      method: "POST",
      url: apiurl + "pharmacy/insert_mas_pharm_medicine_rate",
      data: {
        ...medicineRateApiData,
      },
    })
      .then((response) => {
        this.setState({ props_loading: false });
        this.props.closemodal();
        if (response.data.msg !== "Failed") {
          const { t } = this.props;
          const medicine_added = t("medicine_added");
          // this.props.handleopenSuccess("Medicine added successfully!", true);
          this.props.handleopenSuccess(medicine_added, true);
        }
        else {
          this.props.handleopenSuccess(response.data.data[0].message, false);
        }
        this.props.getTableData();
      })
      .catch((error) => {
        console.error(error);
      });
    this.setState({ disableBtn: false })
  };

  medicineRateUpdateApi = (medicineRateApiData) => {
    this.setState({ disableBtn: true, props_loading: true });
    axiosInstance({
      method: "POST",
      url: apiurl + "pharmacy/edit_mas_pharm_medicine_rate",
      data: {
        id: this.props.editData.id,
        ...medicineRateApiData,
      },
    })
      .then((response) => {
        const { t } = this.props;
        this.setState({ props_loading: false, disableBtn: false });
        if (response.data && (response.data.status === 1 || response.data.ErrorCode === "9999")) {
          const medicine_updated = t("medicine_updated");
          this.props.closemodal();
          this.props.handleopenSuccess(medicine_updated, true);
          this.props.getTableData();
        } else {
          notification.error({
            message: response.data?.message || "Failed to update medicine. Please try again.",
            placement: "topRight",
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ props_loading: false, disableBtn: false });
        notification.error({
          message: "Error updating medicine. Please try again.",
          placement: "topRight",
        });
      });
  };

  componentDidMount() {
    // Assigning Edit Data
    const { editData, editOpenModal } = this.props;
    if (editOpenModal === true && editData) {
      const medicineRate = { ...this.state.medicineRate };
      medicineRate.medicine_name = { ...medicineRate.medicine_name, value: editData.medicine_name || "" };
      medicineRate.medicine_rate = { ...medicineRate.medicine_rate, value: editData.unit_rate || "" };
      medicineRate.medicine_percentage = { ...medicineRate.medicine_percentage, value: editData.commission_percentage || "" };
      this.setState({ editId: editData.id, medicineRate });
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div className="medicine_ratedetails">
        <Spin className="spinner_align" spinning={this.state.props_loading}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <div className="medicine_input">

                <Labelbox
                  type="text"
                  t={t}
                  // labelname="Option 1 (for adding one medicine)"
                  labelname={t("Option_for_adding")}
                  valuelabel={"medicine_name"}
                  changeData={(data) => this.changeDynamic(data, "medicine_name")}
                  value={this.state.medicineRate.medicine_name.value}
                  error={this.state.medicineRate.medicine_name.error}
                  errmsg={this.state.medicineRate.medicine_name.errmsg}
                  placeholder={t("enter_medicine_name")}
                  required
                />
              </div>
            </Grid>
            <Grid item xs={12} md={12}>
              <div className="medicine_input">
                <Labelbox
                  className="input_filed_add"
                  type="text"
                  labelname={t("unit_rate_with_kwd")}
                  valuelabel={"medicine_rate"}
                  changeData={(data) => {
                    this.changeDynamic(data, "medicine_rate")
                  }}
                  value={this.state.medicineRate.medicine_rate.value}
                  error={this.state.medicineRate.medicine_rate.error}
                  errmsg={this.state.medicineRate.medicine_rate.errmsg}
                  placeholder={t("enter_rate")}
                  required
                />
              </div>
            </Grid>
            <Grid item xs={12} md={12}>
              <div className="medicine_input">
                <Labelbox
                  type="text"
                  labelname={t("incentive_percentage")}
                  valuelabel={"medicine_percentage"}
                  changeData={(data) => this.changeDynamic(data, "medicine_percentage")}
                  value={this.state.medicineRate.medicine_percentage.value}
                  error={this.state.medicineRate.medicine_percentage.error}
                  errmsg={this.state.medicineRate.medicine_percentage.errmsg}
                  placeholder={t("enter_percentage")}
                  required
                />
              </div>
            </Grid>
            {/* <Grid item xs={6} md={6}>
            <div className="medicine_details">
              <div className="dosage">
                <Labelbox
                  type="text"
                  labelname="Dosage"
                  valuelabel={"dosage"}
                  changeData={(data) => this.changeDynamic(data, "dosage")}
                  value={this.state.medicineRate.dosage.value}
                  error={this.state.medicineRate.dosage.error}
                  errmsg={this.state.medicineRate.dosage.errmsg}
                  required
                />
              </div>
              <div className="medicine_mg">
                <Labelbox
                  type="select"
                  valuelabel={"mg"}
                  valuebind={"medicine_mg"}
                  dropdown={this.state.medicineMg}
                  changeData={(data) => this.changeDynamic(data, "medicine_mg")}
                  value={this.state.medicineRate.medicine_mg.value}
                  error={this.state.medicineRate.medicine_mg.error}
                  errmsg={this.state.medicineRate.medicine_mg.errmsg}
                />
              </div>
            </div> 
          </Grid>*/}
            {this.props.editOpenModal === false &&
              <>
                <Grid item xs={12} md={12}>
                  <div className="medicine_input">
                    <Labelbox
                      type="download"
                      // labelname="Download excel sheet"
                      labelname={t("download_exce_sheet")}
                      valuelabel={"Download excel sheet"}
                      changeData={(data) => this.changeDynamic(data, "medicine_xlsheet")}
                      // value="Download excel sheet"
                      value={t("download_exce_sheet")}
                      error={this.state.medicineRate.medicine_xlsheet.error}
                      errmsg={this.state.medicineRate.medicine_xlsheet.errmsg}

                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={12}>
                  <div className="medicine_input">
                    <Labelbox
                      type="file"
                      labelname={t("For adding Additional medicine (Add only the new line item)")}
                      valuelabel={"medicine_xlsheet"}
                      changeData={(data) => this.changeDynamic(data, "medicine_xlsheet")}
                      value={this.state.medicineRate.medicine_xlsheet.value}
                      error={this.state.medicineRate.medicine_xlsheet.error}
                      errmsg={this.state.medicineRate.medicine_xlsheet.errmsg}
                      required
                    />
                  </div>
                </Grid>
              </>
            }
            <Grid item xs={12} md={12}>
              <div className="medibutt_container">
                <Button className="submit" onClick={this.checkValidation} disabled={this.state.disableBtn}>
                  {this.props.editOpenModal === false ? t("add") : t("update")}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Spin>
      </div>
    );
  }
}
